function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 10"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 2h-2V1a1 1 0 00-2 0v1H6V1a1 1 0 00-2 0v1H2a2.003 2.003 0 00-2 2v18a2.003 2.003 0 002 2h20a2.003 2.003 0 002-2V4a2.003 2.003 0 00-2-2zm0 2v2H2V4zM2 22V8h20l.002 14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 10h2v2H9zM17 10h2v2h-2zM13 10h2v2h-2zM9 14h2v2H9zM5 14h2v2H5zM17 14h2v2h-2zM13 14h2v2h-2zM9 18h2v2H9zM5 18h2v2H5zM13 18h2v2h-2z"
})));